import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-dailog',
  templateUrl: './warning-dailog.component.html',
  styleUrls: ['./warning-dailog.component.scss']
})
export class WarningDailogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}
